import BugsnagError from '../bugsnag/bugsnagError'

export class WizardSuccessError extends BugsnagError {
  public clientUuid: string

  public personId: string

  public origin: string

  public traversalUuid?: string

  public transactionId: string

  constructor(
    message: string,
    clientUuid: string,
    personId: string,
    origin: string,
    transactionId: string,
    traversalUuid?: string,
  ) {
    super(message)
    this.clientUuid = clientUuid
    this.personId = personId
    this.origin = origin
    this.traversalUuid = traversalUuid
    this.transactionId = transactionId
    this.name = 'WizardSuccessError'
  }

  // eslint-disable-next-line class-methods-use-this
  getMetadata() {
    return {
      dac: {
        clientUuid: this.clientUuid,
        personId: this.personId,
        origin: this.origin,
        traversalUuid: this.traversalUuid,
        transactionId: this.traversalUuid,
      },
    }
  }
}
